<template>
    <div>

        <h4>{{ 'List of quarterly invoices' | trans }}</h4>

        <Spinner v-bind:title="'Getting Invoices Please Wait'|trans" v-show="loading"></Spinner>

        <RouterLink to="invoices"  class="btn btn-primary full-width">
            <i class="fa fa-arrow-circle-left "></i> &nbsp; <span class="title">{{ 'back to list of invoices' | trans }}</span>
        </RouterLink>

        <div v-show=" invoices.length===0 && !loading" class="alert alert-info">
            {{'Nothing to show'|trans}}
        </div>

        <a v-for="invoice in invoices" v-show="!loading" target="_blank" v-bind:href="getInvoicePath(invoice.absolute)" class="btn btn-default full-width">
            <i class="fa fa-file-pdf-o"></i>
            {{invoice.relative}} &nbsp; {{invoice.size}}
        </a>

    </div>
</template>

<script>
    import Spinner from '../Spinner';
    export default {
        props: {},
        data() {
            return {
                invoices : [],
                loading : false,
                search : {
                    documentType:'invoice',
                    dateFrom  : null,
                    dateUntil : null
                }
            }
        },
        created() {
            this.getDocuments();
        },
        methods: {
            async getDocuments() {
                this.loading = true;
                const response = await this.$api.documents.getListOfQuarterlyPdfOfWorker();
                this.invoices = response.files.map((invoice)=>{
                    invoice.isOpen = false;
                    return invoice;
                });
                this.loading = false;
            },
            getInvoicePath(path){
                return  process.env.VUE_APP_API_BASE_URL + path;
            }
        },
        components:{
            Spinner,
        }

    }
</script>

<style scoped>
    .document{
        background-color: white;
        border: 1px solid #e4e4e4;
        margin-bottom: 15px;
    }

    .document-header{
        padding:8px;
    }

    .document-body{
        padding:8px;
        background:#efecec;
    }

    .day{
        font-size:23px;
        color: #cdcdcd;
    }
    .month{
        color: #cdcdcd;
        text-transform: capitalize;
    }

    .search-block{
        background: #dceaea;
        display: inline-block;
        width: 100%;
        padding: 8px 2px;
        position: relative;
    }


</style>

